import { forwardRef, useId } from 'react';
import { Checkbox, type CheckboxProps } from '../ui/Checkbox';

export interface CheckboxFieldProps extends CheckboxProps {
  error?: string;
}

/** Checkbox with error display, for RHF-bound boolean flags. */
export const CheckboxField = forwardRef<HTMLInputElement, CheckboxFieldProps>(
  function CheckboxField({ error, ...checkboxProps }, ref) {
    const errorId = useId();

    return (
      <div className="flex flex-col gap-1">
        <Checkbox
          ref={ref}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? errorId : undefined}
          {...checkboxProps}
        />
        {error && (
          <p id={errorId} role="alert" className="pl-6 text-xs text-danger">
            {error}
          </p>
        )}
      </div>
    );
  },
);

CheckboxField.displayName = 'CheckboxField';
